module.exports = __webpack_public_path__ + "static/amos-bow-1c76a54e9e11d31bcc3b4e70afd3c860.png";